import { z } from "zod";

import { Intent } from "@/shared/agent-prompts/workflow-types";

/** Persisted with the send claim, before Twilio can accept the reply. */
export const smsAgentReplyStateSchema = z
  .object({
    workflowId: z.string().uuid().nullable(),
    workflowStatusAt: z.string().datetime().nullable(),
    conversationStatusAt: z.string().datetime().nullable(),
    intent: z.nativeEnum(Intent),
    workflowCompleted: z.boolean(),
    transitionAppliedAt: z.string().datetime().nullable(),
    workflowCompletedAt: z.string().datetime().nullable(),
    finalizedAt: z.string().datetime().nullable(),
  })
  .refine(
    (state) =>
      state.workflowId === null
        ? state.intent === Intent.NonActionable && !state.workflowCompleted
        : state.intent !== Intent.NonActionable &&
          state.workflowStatusAt !== null &&
          state.conversationStatusAt !== null,
    "Actionable replies require a workflow; non-actionable replies cannot complete one"
  )
  .refine(
    (state) => !state.workflowCompletedAt || (state.workflowCompleted && state.transitionAppliedAt !== null),
    "Workflow completion requires an applied completion transition"
  )
  .refine(
    (state) => !state.finalizedAt || state.transitionAppliedAt !== null,
    "Finalization requires a transition checkpoint"
  );

export type SmsAgentReplyState = z.infer<typeof smsAgentReplyStateSchema>;
